// extracted by mini-css-extract-plugin
module.exports = {"fabRoot":"styles_fabRoot__qlF5v","mobile":"styles_mobile__1LHcJ","fabText":"styles_fabText__3JQ-n","desktop":"styles_desktop__36Zf9"};